module.exports = __webpack_public_path__ + "static/media/specialFood.a8574f1a.jpg";